module.exports = __webpack_public_path__ + "media/site_templates/www.cheapgardenservices.com.au/images/about_us-0593a894e1452d3866f7bf671a8cc89e.jpg";